import { DialogResultVm } from "../checkresultdialog/dialogresultvm";
import { Logger } from "../logger/logger";

export class ObjectHelper {
	/**
	 * Methods get copy of merged object
	 * @param source Object take as master (take from if conflict)
	 * @param target Object take as base
	 */
	public static getDeepMerged(source: any, target: any): any {
		return $.extend(true, {}, target, source);
	}

	public static getDeepCopy(source: any) {
		if (source == null) {
			return source;
		}
		try {
			return JSON.parse(JSON.stringify(source));
		}
		catch (err) {
			Logger.error({ source, err });
		}
	}

	public static getTypedMerge<T>(source: T, target: T, deep: boolean = true): T {
		source = source || {} as T;
		target = target || {} as T;
		return $.extend(deep, {}, target, source);
	}

	public static sizeOfWithLimit(source: any, limit: number) {
		let objs = [source];
		let size = 0;

		let reachedLimit = () => {
			return size >= limit;
		};

		for (let obj of objs) {
			switch (typeof obj) {
				case "boolean":
					size += 4;
					if (reachedLimit()) { return limit; }
					break;
				case "number":
					size += 8;
					if (reachedLimit()) { return limit; }
					break;
				case "string":
					size += 2 * obj.length;
					if (reachedLimit()) { return limit; }
					break;
				case "object":
					if (Object.prototype.toString.call(obj) !== "[object Array]") {
						for (let key of Object.keys(obj)) {
							size += 2 * key.length;
							if (reachedLimit()) { return limit; }
						}
					}

					for (let key of Object.keys(obj)) {
						let processed = false;
						for (let search of objs) {
							if (search === obj[key]) {
								processed = true;
								break;
							}
						}

						if (!processed) {
							objs.push(obj[key]);
						}
					}
					break;

				default:
					break;
			}
		}
		if (reachedLimit()) { return limit; }
		return size;
	}

	public static sizeOf(source: any) {
		return ObjectHelper.sizeOfWithLimit(source, Number.MAX_SAFE_INTEGER);
	}

	public static jsonSize(source: any) {
		if (source == null) {
			return 0;
		}

		// return multiply by 2 because chars are always two bytes long
		return JSON.stringify(source).length * 2;
	}
}